import CargoItem from "./cargo-item.container";

export default CargoItem;
